import { useCallback } from 'react';
import { useStore } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import type { RootState } from '@swf/core/store';
import type { PlaceBetResp, PlaceBetsRequest } from '@swf/sports/types/place-bet';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';

/**
 * Extends the useRequest hook with a fixed URL/Method and typings for the Bet Placement API
 */
const useRequestBetPlacement = () => {
  const { getState } = useStore<RootState>();
  const request = useRequest();
  const boundRequest = useCallback((options) => request(options).toPromise(), [request]);
  const sportsRequest = buildSportsRequest(boundRequest, getState());

  const placeBet = useCallback(
    (body: PlaceBetsRequest) =>
      sportsRequest<PlaceBetResp>({
        path: '/gbp/spb/placeBet',
        method: 'POST',
        body
      }),
    [sportsRequest]
  );

  return placeBet;
};

export default useRequestBetPlacement;
